import type { PropsWithChildren } from "react";

interface SectionHeadingProps extends PropsWithChildren {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  children,
}: SectionHeadingProps) {
  const alignment = align === "center" ? "mx-auto text-center" : "";

  return (
    <div className={`max-w-3xl space-y-5 ${alignment}`}>
      <p className="eyebrow">{eyebrow}</p>
      <div className="space-y-4">
        <h2 className="font-display text-3xl leading-tight text-text md:text-5xl">{title}</h2>
        {description ? <p className="max-w-2xl text-base leading-7 text-muted md:text-lg">{description}</p> : null}
      </div>
      {children}
    </div>
  );
}
